import React from 'react';
import { BuildPcModalContent } from './BuildPcModalContent.es.js';
import { BuildPcModalHeader } from './BuildPcModalHeader.es.js';
import { Card } from '@teko/ui';

const BuildPcModal = ({
  filters,
  products,
  activeValues = [],
  onClickFilter,
  onClickSort,
  onClickProduct,
  loading = false,
  searchParams
}) => /* @__PURE__ */ React.createElement(Card, null, /* @__PURE__ */ React.createElement(BuildPcModalHeader, {
  searchParams,
  onClickSort,
  onClickFilter: onClickFilter || (() => {
  }),
  filters,
  activeValues
}), /* @__PURE__ */ React.createElement(BuildPcModalContent, {
  isLoading: loading,
  onClick: onClickProduct || (() => {
  }),
  products
}));

export { BuildPcModal };
